// KPI page (docs/design.md §13): response shapes for /api/admin/kpis and the pure rules the API and the page share.
// Dates are plain 'YYYY-MM-DD' in the lead's time zone (LEAD_TIMEZONE); weeks start on Monday.
export const KPI_BUG_WEEKS = [12, 26];
export const KPI_HOURS_WINDOWS = ['all', '90'];
export const TIME_CATEGORIES = ['onboarding', 'support'];
const DAY_MS = 86_400_000;
const parse = (d) => { const [y, m, day] = d.split('-').map(Number); return Date.UTC(y, m - 1, day); };
const fmt = (ms) => new Date(ms).toISOString().slice(0, 10);
export const isDateOnly = (s) => /^\d{4}-\d{2}-\d{2}$/.test(s) && fmt(parse(s)) === s;
export const daysBetween = (from, to) => Math.round((parse(to) - parse(from)) / DAY_MS);
export const addDays = (d, n) => fmt(parse(d) + n * DAY_MS);
/** The Monday on or before `d`. */
export const weekStart = (d) => addDays(d, -((new Date(parse(d)).getUTCDay() + 6) % 7));
export const round1 = (n) => Math.round(n * 10) / 10;
/**
 * Where the paid-seats goal says we should be today, and where the last 30 days' rate lands on the goal date.
 * `paid` and `paid30DaysAgo` are running totals; the pace line is straight from 0 on `startOn` to `target` on `targetOn`.
 */
export function seatPace(goal, today, paid, paid30DaysAgo) {
    const span = Math.max(1, daysBetween(goal.startOn, goal.targetOn));
    const elapsed = Math.min(span, Math.max(0, daysBetween(goal.startOn, today)));
    const expectedToday = (goal.target * elapsed) / span;
    const perDay = Math.max(0, (paid - paid30DaysAgo) / 30);
    const daysLeft = Math.max(0, daysBetween(today, goal.targetOn));
    return {
        expectedToday: Math.round(expectedToday),
        aheadBy: Math.round(paid - expectedToday),
        projectedAtTarget: Math.round(paid + perDay * daysLeft),
    };
}
/** Share of the seats active at the start of the window that are still active, in percent (whole number). */
export function retentionRate(atStart, kept) {
    return atStart > 0 ? Math.round((kept / atStart) * 100) : null;
}
//# sourceMappingURL=kpi.js.map